import { MoreOutlined } from '@ant-design/icons'
// import useModal from '@hooks/useModal'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Table, TableColumnType, Tag } from 'antd'
import dayjs from 'dayjs'
import { BranchCards } from 'gadjet-v2-types/dist/model'

import TableWrapper from '@components/atoms/TableWrapper'
import { BranchCardAction } from '@components/organisms/Branch/Config/Tabs/BranchCard'

// import CancelSubscriptionConfirm from '../../Modals/CancelSubscriptionConfirm'

type Props = {
  branchCards: BranchCards[]
  onAction: (action: BranchCardAction, branchCardId?: number) => void
}

export default function BranchCardTable({ branchCards, onAction }: Props): JSX.Element {
  // TODO: 해지하기 기능 완성시 주석해제
  // const [cancelSubsConfirmModal, onVisibleCancelSubsConfirmModal, onCloseCancelSubsConfirmModal] = useModal({
  //   visible: false,
  // })

  const columns: TableColumnType<BranchCards>[] = [
    { key: 'cardName', dataIndex: 'cardName', title: '이름' },
    { key: 'cardNumber', dataIndex: 'cardNumber', title: '번호' },
    {
      key: 'registDate',
      dataIndex: 'registDate',
      title: '등록일',
      render: (registDate) => dayjs(registDate).format('YYYY-MM-DD'),
    },
    {
      key: 'billingFlag',
      dataIndex: 'billingFlag',
      title: '활성화',
      render: (_, { billingFlag }) => {
        if (!billingFlag) return <></>
        return <Tag color="blue">활성화</Tag>
      },
    },
    {
      key: 'branchCardId',
      dataIndex: 'branchCardId',
      title: '',
      width: '80px',
      render: (_, { branchCardId, billingFlag }) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item disabled={billingFlag} onClick={() => onClickActive(branchCardId)}>
                활성화
              </Menu.Item>
              <Menu.Item disabled={billingFlag} onClick={() => onClickRemove(branchCardId)}>
                삭제
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  const onClickRemove = (branchCardId: number) => onAction('delete', branchCardId)
  const onClickActive = (branchCardId: number) => onAction('active', branchCardId)

  return (
    <>
      <Button type="primary" onClick={() => onAction('add')} style={styles.addCard}>
        카드추가
      </Button>
      <TableWrapper>
        <Table<BranchCards>
          pagination={false}
          columns={columns}
          dataSource={branchCards}
          rowKey={({ branchCardId }) => `${branchCardId}`}
        />
      </TableWrapper>
      {/* TODO: 해지하기 기능 완성시 주석해제 */}
      {/* <div style={styles.bottomCol}>
        <Button type="link" style={styles.cancelService} onClick={() => onVisibleCancelSubsConfirmModal()}>
          <div style={styles.cancelServiceText}>해지하기</div>
        </Button>
      </div>
      <CancelSubscriptionConfirm visible={cancelSubsConfirmModal.visible} onClose={onCloseCancelSubsConfirmModal} /> */}
    </>
  )
}

const styles: Styles = {
  addCard: {
    marginBottom: '10px',
  },
  bottomCol: {
    display: 'flex',
    flexDirection: 'row-reverse',
    paddingTop: '24px',
  },
  cancelService: {
    fontSize: '14px',
    color: '#9A9C9C',
    padding: '0',
    display: 'flex',
    alignItems: 'flex-start',
  },
  cancelServiceText: {
    textDecoration: 'underline',
  },
}
